import {
  put, takeLatest,
} from 'redux-saga/effects';
import {
  getJobApplications,
  updateJobApplication,
  cancelRejectionEmail,
  createJobApplicationAdmin,
  deleteJobApplication,
  sendInterviewInvite,
} from '../../api/jobApplications';
import parseAxiosError from '../../utils/helpers/parseAxiosError';
import {
  getJobApplicationsActionCreators,
  updateJobApplicationActionCreators,
  cancelRejectionEmailActionCreators,
  createJobApplicationAdminActionCreators,
  deleteJobApplicationActionCreators,
  sendInterviewInviteActionCreators,
} from '../actions/jobApplicationsActionCreators';
import {
  getJobApplicationsConstants,
  updateJobApplicationConstants,
  cancelRejectionEmailConstants,
  createJobApplicationAdminConstants,
  deleteJobApplicationConstants,
  sendInterviewInviteConstants,
} from '../constants/jobApplicationsConstants';

function* getJobApplicationSaga({ payload: { pointer } }) {
  yield put(getJobApplicationsActionCreators.pending());
  try {
    const result = yield getJobApplications(pointer, 500);
    const {
      data: { data: jobApplications },
    } = result;
    // eslint-disable-next-line no-underscore-dangle
    const id = result.data?._meta?.pagination?.pointer?.id;
    yield put(getJobApplicationsActionCreators.fulfilled(jobApplications, { pointer: id }));
  } catch (e) {
    const errorParsed = parseAxiosError(e);
    yield put(getJobApplicationsActionCreators.rejected(errorParsed));
  }
}

function* updateJobApplicationSaga({
  payload: {
    id, phase, status, interviewFormat, interviewDateTime, durationMinutes,
    taskDeadline, taskLink, adminNotes, notesOnly, sendEmail, rejectionScheduledAt,
    profileOnly, applicantName, email, jobPosition, base64File, filename, fileURL, metadata,
  },
}) {
  yield put(updateJobApplicationActionCreators.pending());
  try {
    const result = yield updateJobApplication(id, {
      phase,
      status,
      interviewFormat,
      interviewDateTime,
      durationMinutes,
      rejectionScheduledAt,
      taskDeadline,
      taskLink,
      adminNotes,
      notesOnly,
      sendEmail,
      profileOnly,
      applicantName,
      email,
      jobPosition,
      base64File,
      filename,
      fileURL,
      metadata,
    });
    const { data: { data } } = result;
    yield put(updateJobApplicationActionCreators.fulfilled(data));
  } catch (e) {
    const errorParsed = parseAxiosError(e);
    yield put(updateJobApplicationActionCreators.rejected(errorParsed));
  }
}

function* cancelRejectionEmailSaga({ payload: { id } }) {
  yield put(cancelRejectionEmailActionCreators.pending());
  try {
    const result = yield cancelRejectionEmail(id);
    const { data: { data } } = result;
    yield put(cancelRejectionEmailActionCreators.fulfilled(data));
  } catch (e) {
    const errorParsed = parseAxiosError(e);
    yield put(cancelRejectionEmailActionCreators.rejected(errorParsed));
  }
}

function* deleteJobApplicationSaga({ payload: id }) {
  yield put(deleteJobApplicationActionCreators.pending());
  try {
    const result = yield deleteJobApplication(id);
    const { data: { data } } = result;
    yield put(deleteJobApplicationActionCreators.fulfilled(data));
  } catch (e) {
    const errorParsed = parseAxiosError(e);
    yield put(deleteJobApplicationActionCreators.rejected(errorParsed));
  }
}

function* createJobApplicationAdminSaga({ payload }) {
  yield put(createJobApplicationAdminActionCreators.pending());
  try {
    const result = yield createJobApplicationAdmin(payload);
    const { data: { data } } = result;
    yield put(createJobApplicationAdminActionCreators.fulfilled(data));
  } catch (e) {
    const errorParsed = parseAxiosError(e);
    yield put(createJobApplicationAdminActionCreators.rejected(errorParsed));
  }
}

function* sendInterviewInviteSaga({
  payload: {
    id, interviewDateTime, durationMinutes, interviewType, interviewFormat, ccEmails,
  },
}) {
  yield put(sendInterviewInviteActionCreators.pending());
  try {
    const result = yield sendInterviewInvite(id, {
      interviewDateTime, durationMinutes, interviewType, interviewFormat, ccEmails,
    });
    const { data: { data } } = result;
    yield put(sendInterviewInviteActionCreators.fulfilled(data));
  } catch (e) {
    const errorParsed = parseAxiosError(e);
    yield put(sendInterviewInviteActionCreators.rejected(errorParsed));
  }
}

export default function* rootSaga() {
  yield takeLatest(getJobApplicationsConstants.name, getJobApplicationSaga);
  yield takeLatest(updateJobApplicationConstants.name, updateJobApplicationSaga);
  yield takeLatest(cancelRejectionEmailConstants.name, cancelRejectionEmailSaga);
  yield takeLatest(createJobApplicationAdminConstants.name, createJobApplicationAdminSaga);
  yield takeLatest(deleteJobApplicationConstants.name, deleteJobApplicationSaga);
  yield takeLatest(sendInterviewInviteConstants.name, sendInterviewInviteSaga);
}
